export default __webpack_public_path__ + "static/media/sass.95acddf0.png";